import React, {
  createContext, ReactNode, useMemo,
} from 'react';
import { Site } from '../resources/modelTypes';
import { isUsingNewComponents } from '../add-element/utils';

export type StaticSiteData = {
  id: number,
  isDemoSite: boolean,
  isHolidaySite: boolean,
  isOnlineInvitationSite: boolean,
  isUsingNewComponents: boolean,
  isWeddingSite: boolean,
}

export const StaticSiteDataContext = createContext<StaticSiteData>({
  id: 0,
  isDemoSite: false,
  isHolidaySite: false,
  isOnlineInvitationSite: false,
  isUsingNewComponents: false,
  isWeddingSite: false,
});

export type StaticSiteDataProviderProps = {
  children: ReactNode,
  site: Site
}

export const StaticSiteDataProvider = ({
  children, site,
}: StaticSiteDataProviderProps) => {
  const providerValue = useMemo(() => ({
    id: site.id,
    isDemoSite: site.isDemoSite || false,
    isHolidaySite: site.isHoliday,
    isOnlineInvitationSite: site.isOnlineInvitation,
    isUsingNewComponents: isUsingNewComponents(site),
    isWeddingSite: site.isWedding,
  }), [
    site,
  ]);

  return (
    <StaticSiteDataContext.Provider value={providerValue}>
      {children}
    </StaticSiteDataContext.Provider>
  );
};
